module.exports = __webpack_public_path__ + "media/src/admin/images/logo-1-9a0111c05c69028e40124e1090355688.png";